// removed by extract-text-webpack-plugin
module.exports = {"container":"_1JOwCDWmDq5S8im3PfqgAu","text":"_1b0JjSov3tHvpGAIZHrpzR","marker":"_8sNzL7hwvadfwoJCnH3we","top":"_2vaSq9ort06LloS0Z5UDye","addressLine":"_3jaK1A3RDvq_6frzhGLa0u","header":"_1r3lQZxUSx07xQPfVfCCCQ","opening":"_2HWpUSzVGq4R6sRbZAbaEB","openingRow":"lE4LkkAB3TmoQo9iC2T73","days":"QFt_WhpEkLcQZUlwthwpQ","hours":"_33CBeacUL3PCTwbDSSlxvz","buttonContainer":"P4w-4ohnLQb_eP5Z9uYGA","button":"_2QhzOxjnPpdzPyk4DHqmuN","accessibility":"_2eQBsEKscK_7hx1Oe4iqU0"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/PickupLocator/Details/style.scss
// module id = 974
// module chunks = 0